{
	"main": {
		"title": "Daily schedule",
		"subtitle1": "FLIGHT SCHEDULE:",
		"subtitle2": "WARNING",
		"subSubtitle2": "FOR OTHER AIR ACTIVITIES:",
		"nazaj": "Back"
	},
	"nav": {
		"vnos": "Input",
		"zapisi": "Records"
	},
	"labels": {
		"planirano": "Planned (Route, Circuit, Training,..)",
		"sredstvoTitle": "Asset:",
		"sredstvo": "",
		"izvrsilec": "Executor (First name, Last name)",
		"vrstaLetala": "Select aircraft type: ",
		"casAktivnosti": "Activity time:",
		"opisAktivnosti": "Activity description (e.g. Parachutists in airport area..)",
		"naloga": "Select task: "
	},
	"buttons": {
		"dodajSredstvo": "Add means",
		"vnesiRazpored": "Add to schedule",
		"vnesiOpozorilo": "Add warning",
		"brisiIzbiro": "Clear selection"
	},
	"obvestila": {
	  	"brisiSredstvo": "Do you really want to delete the asset?",
	  	"vnosUspesen": "entry successful",
	  	"vnosNeuspesen": "Error while entering data.",
		"napakaInputa": "You haven't filled in all the fields! Please fill in all the fields!"
	}
}